/**
* sidebar
*/

import Component, { publish } from "../../js/lib/component";

const classList = {
  root: ".js-sidebar",
  close: ".js-sidebar-close",
};

export default class Sidebar extends Component {
  events() {
    this.$.close.on('click', () => publish('sidebar:hide'));
  }
}

Component.mount(Sidebar, {
  name: "Sidebar",
  classList,
  state: {}
});
